// extracted by mini-css-extract-plugin
export default {"authenticationSuccessMessage":"authenticationSuccessMessage_SRyfOpL","icon":"icon_vBzq9Wl","icon_danger":"icon_danger_uYApd32","message":"message_RlomIbS","button":"button_PFhI2Qh"};